import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-eventsandwebinars',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './eventsandwebinars.component.html',
  styleUrls: ['./eventsandwebinars.component.scss']
})
export class EventsandwebinarsComponent {
  constructor(private translate: TranslateService) {}
}
